<template>
  <div class="middleStatistics-container">
    <DataPresentation
      title="累计生产"
      :number="cumulative"
    ></DataPresentation>
    <div class="today-production">
      <DataPresentationSmall
        title="今日生产"
        :number="today"
      ></DataPresentationSmall>
    </div>
    <div class="logs-card">
      <Logs :stateInfoList="stateInfoList"></Logs>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import DataPresentation from './MiddleStatistics/DataPresentation.vue';
import DataPresentationSmall from './MiddleStatistics/DataPresentationSmall.vue';
import Logs from './MiddleStatistics/Logs.vue';

export default {
  name: 'MiddleStatistics',
  components: {
    DataPresentation,
    DataPresentationSmall,
    Logs
  },
  data () {
    return {
      cumulative: 0,
      today: 0,
      timer: '',
      stateInfoList: []
    }
  },
  mounted () {
    this.handleCumulativeReq()
    this.handleTodayReq()
    this.timer = setInterval(() => {
      this.handleCumulativeReq()
      this.handleTodayReq()
    }, 1000 * 60)
  },
  methods: {
    handleAdd (arr) {
      let result = 0;
      for (let ele of arr) {
        result += Number(ele)
      }
      return result
    },
    // handleCumulativeReq () {
    //   let cumulativeReqArr = [
    //     this.$axios({ method: 'get', url: 'https://api.a2.zs-tek.com/BigExhibition/BigExhibition/GetAllProcessData' }),
    //     this.$axios({ method: 'get', url: 'https://api.d1.zs-tek.com/Production/GetTotalCount' }),
    //     this.$axios({ method: 'get', url: 'https://api.d2.zs-tek.com/Production/GetTotalCount' }),
    //     // this.$axios({ method: 'get', url: 'https://api.y1.zs-tek.com/Production/GetTotalCount' }),
    //     this.$axios({ method: 'get', url: 'https://api.e1.zs-tek.com/Production/GetTotalCount' }),
    //     this.$axios({ method: 'get', url: 'https://api.jdd3.zs-tek.com/Production/GetTotalCount' }),
    //     this.$axios({ method: 'get', url: 'https://api.s1.zs-tek.com/Production/GetTotalCount' }),
    //     this.$axios({ method: 'get', url: 'https://api.x.zs-tek.com/Production/GetTotalCount' }),
    //   ]
    //   this.$axios.all(cumulativeReqArr).then(this.$axios.spread((a2, d1, d2, e1, jdd3, s1, x) => {
    //     let cumulativeTem = this.handleAdd([a2.data.processCount, d1.data, d2.data || 961000, 375, e1.data, jdd3.data, s1.data, x.data]);
    //     // 添加T1总产量
    //     cumulativeTem = cumulativeTem + 23000
    //     if (this.cumulative < cumulativeTem) {
    //       this.cumulative = cumulativeTem
    //       localStorage.setItem("zs-tek-bigdata", JSON.stringify(cumulativeTem))
    //     }
    //   })).catch((err) => {
    //     if (localStorage.getItem("zs-tek-bigdata")) {
    //       this.cumulative = localStorage.getItem("zs-tek-bigdata")
    //     }
    //   })
    // },
    handleCumulativeReq () {
      let cumulativeTem = 0;
      let stateInfoListTem = [];
      const errorInfoList = [
        'A2产线通讯异常',
        'D1产线通讯异常',
        'D2产线通讯异常',
        'E1产线通讯异常',
        'JDD3产线通讯异常',
        'S产线通讯异常',
        'X产线通讯异常'
      ]
      let cumulativeReqArr = [
        { method: 'get', url: 'https://api.a2.zs-tek.com/BigExhibition/BigExhibition/GetAllProcessData' },
        { method: 'get', url: 'https://api.d1.zs-tek.com/Production/GetTotalCount' },
        { method: 'get', url: 'https://api.d2.zs-tek.com/Production/GetTotalCount' },
        { method: 'get', url: 'https://api.e1.zs-tek.com/Production/GetTotalCount' },
        { method: 'get', url: 'https://api.jdd3.zs-tek.com/Production/GetTotalCount' },
        { method: 'get', url: 'https://api.s1.zs-tek.com/Production/GetTotalCount' },
        { method: 'get', url: 'https://api.x.zs-tek.com/Production/GetTotalCount' },
      ]
      Promise.allSettled(cumulativeReqArr.map(({ method, url }) =>
      // fetch(url, { method, timeout: 5000 })
      //   .then(response => response.json())
      //   .catch(error => ({ error }))
      {
        return axios({
          method: method, // 请求方法，如 'GET'、'POST'
          url, // 请求地址
          timeout: 3500, // 设置超时时间为3.5秒
        })
          .then(response => response.data) // 提取响应数据
          .catch(error => ({ error })); // 捕获请求错误
      }
      ))
        .then((results) => {
          results.forEach((result, index) => {
            if (result.status === "fulfilled") {
              if (!isNaN(Number(result.value))) {
                cumulativeTem += Number(result.value)
              } else if (!isNaN(Number(result.value?.processCount))) {
                cumulativeTem += Number(result.value?.processCount)
              } else {
                stateInfoListTem.push(errorInfoList[index])
              }
            } else if (result.status === "rejected") {
              // console.log("Rejected:", result.reason, "Name:", index)
            }
          })
          // 添加Y1总产量
          cumulativeTem = cumulativeTem + 375
          // 添加T1总产量
          cumulativeTem = cumulativeTem + 99107

          if (cumulativeTem < localStorage.getItem("zs-tek-bigdata")) {
            this.cumulative = Number(localStorage.getItem("zs-tek-bigdata"))
          } else {
            this.cumulative = cumulativeTem
            localStorage.setItem("zs-tek-bigdata", JSON.stringify(cumulativeTem))
          }

          this.stateInfoList = stateInfoListTem
        });
    },
    // handleTodayReq () {
    //   let TodayReqArr = [
    //     this.$axios({ method: 'get', url: 'https://api.a2.zs-tek.com/BigExhibition/BigExhibition/GetToDayProcessData' }),
    //     this.$axios({ method: 'get', url: 'https://api.d1.zs-tek.com/Production/GetTodayCount' }),
    //     this.$axios({ method: 'get', url: 'https://api.d2.zs-tek.com/Production/GetTodayCount' }),
    //     // this.$axios({ method: 'get', url: 'https://api.y1.zs-tek.com/Production/GetTodayCount' }),
    //     this.$axios({ method: 'get', url: 'https://api.e1.zs-tek.com/Production/GetTodayCount' }),
    //     this.$axios({ method: 'get', url: 'https://api.jdd3.zs-tek.com/Production/GetTodayCount' }),
    //     this.$axios({ method: 'get', url: 'https://api.s1.zs-tek.com/Production/GetTodayCount' }),
    //     this.$axios({ method: 'get', url: 'https://api.x.zs-tek.com/Production/GetTodayCount' }),
    //   ]
    //   this.$axios.all(TodayReqArr).then(this.$axios.spread((a2, d1, d2, e1, jdd3, s1, x) => {
    //     let todayTem = this.handleAdd([a2.data.goodProcessCount, d1.data, d2.data, 0, e1.data, jdd3.data, s1.data, x.data]);
    //     if (this.today < todayTem) {
    //       this.today = todayTem
    //     }
    //   })).catch((err) => {
    //     this.$message.error('今日生产通讯异常')
    //   })
    // }
    handleTodayReq () {
      let todayTem = 0;
      let TodayReqArr = [
        { method: 'get', url: 'https://api.a2.zs-tek.com/BigExhibition/BigExhibition/GetToDayProcessData' },
        { method: 'get', url: 'https://api.d1.zs-tek.com/Production/GetTodayCount' },
        { method: 'get', url: 'https://api.d2.zs-tek.com/Production/GetTodayCount' },
        //{ method: 'get', url: 'https://api.y1.zs-tek.com/Production/GetTodayCount' },
        { method: 'get', url: 'https://api.e1.zs-tek.com/Production/GetTodayCount' },
        { method: 'get', url: 'https://api.jdd3.zs-tek.com/Production/GetTodayCount' },
        { method: 'get', url: 'https://api.s1.zs-tek.com/Production/GetTodayCount' },
        { method: 'get', url: 'https://api.x.zs-tek.com/Production/GetTodayCount' },
      ]
      Promise.allSettled(TodayReqArr.map(({ method, url }) =>
      // fetch(url, { method, timeout: 5000 })
      //   .then(response => response.json())
      //   .catch(error => ({ error }))
      {
        return axios({
          method: method, // 请求方法，如 'GET'、'POST'
          url, // 请求地址
          timeout: 3500, // 设置超时时间为3.5秒
        })
          .then(response => response.data) // 提取响应数据
          .catch(error => ({ error })); // 捕获请求错误
      }
      ))
        .then((results) => {
          results.forEach((result, index) => {
            if (result.status === "fulfilled") {
              if (!isNaN(Number(result.value))) {
                todayTem += Number(result.value)
              } else if (!isNaN(Number(result.value?.goodProcessCount))) {
                todayTem += Number(result.value?.goodProcessCount)
              }
            } else if (result.status === "rejected") {
              // console.log("Rejected:", result.reason, "Name:", index)
            }
          })
          this.today = todayTem
        });
    }
  },
  beforeDestroy () {
    if (this.timer) {
      clearInterval(this.timer);
    }
  }
}
</script>

<style scoped>
.middleStatistics-container {
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  color: #fff;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
}

.today-production {
  position: absolute;
  top: 0px;
  left: 0px;
}

.logs-card {
  position: absolute;
  bottom: 3px;
  left: 0;
}
</style>
